import request from '@/utils/request'

export function getChargeList(params) {
    return request({
        url: '/v2/fee/chargeList',
        method: 'post',
        data: params
    })
}

export function getUseList(params) {
    return request({
        url: '/v2/fee/useList',
        method: 'post',
        data: params
    })
}

export function getCardreceipt(params) {
    return request({
        url: '/v2/fee/getCardreceipt',
        method: 'post',
        data: params
    })
}

export function getUsePersonList(params) {
    return request({
        url: '/v2/fee/personTaxList',
        method: 'post',
        data: params
    })
}